export const ALL_RENTALS_TABLE = {
  columns: [
    {
      label: 'rentals.system_header',
      field: 'system.name',
      ordering: true,
      getValue(raw) {
        return raw.system.name;
      }
    },
    {
      label: 'rentals.full_name_header',
      field: 'client.firstName,client.lastName',
      getValue: (raw) => {
        return raw.client.firstName + ' ' + raw.client.lastName
      },
      ordering: true
    },
    {
      label: 'rentals.bicycle_header',
      field: 'bike.number',
      getValue: (raw) => {
        return "# " + raw.bike.number
      },
      ordering: true
    },
    {
      label: 'rentals.status_header',
      field: 'status',
      ordering: true,
      translate: true,
      getValue(raw) {
        return 'rental_status.' + raw.status;
      }
    },
    {
      label: 'rentals.start_time_header',
      field: 'startTime',
      getValue: (raw) => {
        return raw.startTime ? raw.startTime : '-'
      },
      ordering: true
    },
    {
      label: 'rentals.end_time_header',
      field: 'endTime',
      getValue: (raw) => {
        return raw.endTime ? raw.endTime : '-'
      },
      ordering: true
    }
  ]
}
